import { useCurrency, CURRENCIES } from '../context/CurrencyContext';
import { ChevronDown } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';

export const CurrencySwitcher = ({ compact = false }) => {
  const { code, setCode } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="currency-switcher-button"
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.22em] ${compact ? 'text-lum-text2 hover:text-lum-text' : ''}`}
      >
        {CURRENCIES[code].symbol} {code} <ChevronDown size={12} />
      </button>
      {open && (
        <div data-testid="currency-switcher-menu" className="absolute right-0 mt-3 min-w-[180px] bg-lum-bg border border-lum-border shadow-lg z-50">
          {Object.values(CURRENCIES).map((c) => (
            <button
              key={c.code}
              data-testid={`currency-option-${c.code}`}
              onClick={() => { setCode(c.code); setOpen(false); }}
              className={`block w-full text-left px-4 py-3 text-xs uppercase tracking-[0.22em] hover:bg-lum-bg2 transition-colors ${c.code === code ? 'bg-lum-bg2' : ''}`}
            >
              {c.symbol} <span className="ml-1">{c.code}</span>
              <span className="block text-[10px] text-lum-muted normal-case tracking-normal mt-0.5">{c.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
